<template>
    <tr @click.prevent="openListing" class="transition duration-200 hover:bg-gray-100 cursor-pointer group">
        <td class="border-b pl-2 py-2 pr-1 sm:pr-2 text-center">
            <div v-if="listing.store.image_url && listing.store.slug !== 'amazon2'" class="store-avatar text-center mx-auto w-12 h-12">
                <img :src="listing.store.image_url" :alt="listing.store.name" class="block p-2 rounded-circle bg-white store-avatar-img mx-auto" class2="w-12 h-12" />
            </div>

            <div v-if="!listing.store.image_url || listing.store.slug === 'amazon2'" class="store-avatar rounded-circle text-center mx-auto w-12 h-12" class2="avatar">
                <div class="block p-2 rounded-circle bg-white w-12 h-12 text-gray-700 mx-auto border">
                    <i class="far fa-store-alt fa-lg"></i>
                </div>
            </div>
        </td>
        <td class="border-b pl-2 pr-4 py-2 sm:pl-0">
            <div class="text-gray-700 font-semibold sm:whitespace-no-wrap group-hover:text-blue-600">
                {{ listing.store.name }}
            </div>

            <div class="text-gray-600 text-xs group-hover:text-gray-800">
                {{ listing.name }}
            </div>
        </td>
        <td class="border-b px-2 sm:px-4 py-2">
            <span class="inline-flex items-center justify-center">
                <span v-if="listing.stocked === true" class="badge badge-success text-xs sm:text-sm font-semibold rounded" class2="text-base">
                    In Stock
                </span>
                <span v-if="listing.stocked === false" class="badge badge-warning text-xs sm:text-sm font-semibold rounded" class2="text-base">
                    Sold Out
                </span>
                <span v-if="listing.stocked === null" class2="badge badge-warning text-xs sm:text-sm font-semibold rounded">
                    &ndash;
                </span>
                <v-popover v-if="listing.stocked !== null && listing.store.slug === 'amazon'" trigger="hover">
                    <button @click.prevent.stop type="button" class="tooltip-target b3 focus:outline-none">
                        <i class="fad fa-info-circle ml-2"></i>
                    </button>
                    <span slot="popover">
                        Product prices and availability are accurate as of the date/time indicated and are subject to change. Any price and availability information displayed on Amazon at the time of purchase will apply to the purchase of this product.
                    </span>
                </v-popover>
            </span>

            <div v-if="isAdminUser">
                <div v-if="listing.checked_at" class="mt-2 text-xs text-gray-600">
                    {{ relative(listing.checked_at) }}
                </div>
            </div>
        </td>
        <td class="border-b px-2 sm:px-4 py-2">
            <div class="font-semibold text-gray-800">
                <span v-if="listing.stocked === true && listing.price !== null" class="inline-flex items-center justify-center text-base" class2="sm:text-lg">
                    <span>
                        {{ currency(listing.price) }}
                    </span>
                    <v-popover v-if="listing.store.slug === 'amazon'" trigger="hover">
                        <button @click.prevent.stop type="button" class="tooltip-target b3 focus:outline-none">
                            <i class="fad fa-info-circle ml-2"></i>
                        </button>
                        <span slot="popover">
                            Product prices and availability are accurate as of the date/time indicated and are subject to change. Any price and availability information displayed on Amazon at the time of purchase will apply to the purchase of this product.
                        </span>
                    </v-popover>
                </span>
                <span v-if="listing.stocked === true && listing.price === null">
                    See Site
                </span>
                <span v-if="listing.stocked === false" class="text-gray-600 font-normal text-xs">
                    <!-- && listing.price === null -->
                    &ndash;
                </span>
                <span v-if="listing.stocked === null" class="text-gray-600 font-normal text-xs">
                    &ndash;
                </span>
            </div>
        </td>
        <td class="border-b px-2 sm:px-4 py-2 hidden sm:table-cell">
            <span v-if="listing.stocked !== true && listing.stocked_at" :title="dateTime3(listing.stocked_at)" class="inline-flex items-center justify-center text-sm text-gray-700">
                <span>
                    {{ dateTime2(listing.stocked_at) }}
                </span>
                <v-popover v-if="listing.store.slug === 'amazon'" trigger="hover">
                    <button @click.prevent.stop type="button" class="tooltip-target b3 focus:outline-none">
                        <i class="fad fa-info-circle ml-2"></i>
                    </button>
                    <span slot="popover">
                        Product prices and availability are accurate as of the date/time indicated and are subject to change. Any price and availability information displayed on Amazon at the time of purchase will apply to the purchase of this product.
                    </span>
                </v-popover>
            </span>
            <span v-else class="text-gray-600 text-xs">
                &ndash;
            </span>
        </td>
        <td class="border-b px-2 sm:px-4 py-2 hidden sm:table-cell text-center">
            <a @click.prevent="openListing" :href="listingUrl" :class="{'btn-primary': listing.stocked, 'btn-secondary': !listing.stocked}" class="btn btn-xs border-2 rounded-full font-semibold">
                <span v-cloak v-if="listing.stocked">
                    <i class="fad fa-shopping-cart fa-lg mr-1"></i>
                    Buy Now
                </span>
                <span v-cloak v-if="!listing.stocked">
                    <i class="far fa-external-link-square fa-lg mr-1"></i>
                    View Item
                </span>
            </a>
        </td>
    </tr>
</template>

<script>
import numeral from "numeral";
import ListingMixin from '../../mixins/listing';

export default {
    mixins: [ListingMixin],

    props: ['listing'],

    data: () => ({}),

    created() {
        Bus.$on("productListingChecked", listing => {
            if (this.listing.id === listing.id) {
                // this.listing = listing;
                this.listing.price = listing.price;
                this.listing.stocked = listing.stocked;
                this.listing.checked_at = listing.checked_at;
                this.listing.stocked_at = listing.stocked_at;
                this.listing.updated_at = listing.updated_at;
            }
        });
    },

    mounted() {},

    computed: {},

    methods: {}
}
</script>

<style lang="scss" scoped>
</style>
